import { useQuery } from 'react-query'
import { axios } from '../../../lib'

interface LoadItemLastSalesParams {
  productId: string
  customerId: string
}

//! TODO: response type

export const loadOrdersCustomerProductLastSale = (
  params: LoadItemLastSalesParams
): Promise<any> => {
  return axios.get(
    `/orders/customers/${params.customerId}/latest-sales/${params.productId}`,
    {
      params: {
        page: 1,
        limit: 100
      }
    }
  )
}

export function useLoadOrdersCustomerProductLastSale(query: any) {
  return useQuery(
    ['ordersCustomerProductLastSale', query],
    () => loadOrdersCustomerProductLastSale(query),
    { enabled: !!query?.customerId && !!query?.productId }
  )
}
